$(window).scroll(function() { // when the page is scrolled run this
    if($(this).scrollTop() != 0) { // if you're NOT at the top
        $('.go_to_top').fadeIn("normal"); // fade in
    } else { // else
        $('.go_to_top').fadeOut("normal"); // fade out
    }
});

$('.go_to_top').click(function() { // when the button is clicked
    $('body,html').animate({scrollTop:0},1000); // return to the top with a nice animation
});
